import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Form, Button } from "react-bootstrap";
import { Buffer } from "buffer"

import { CreateCertificate } from "../../routes/cryptography";

import FileDownload from "js-file-download";

import "bootstrap/dist/css/bootstrap.min.css";

class CreateCert extends Component {
  constructor() {
    super();
    this.state = {
      filekeyname: "файл",
      filekeyIsOpen: false,

      reqFileName: "файл",
      reqFileIsOpen: false,

      filecertname: "файл",
      filecertIsOpen: false,

      isValidReqFileSize: true,
      isValidPrivKeyFileSize: true,

      dataReq: "",
      dataKey: "",
      password: "",
      statusCert: "",
      errors: {},
    };
    this.handleReqChange = this.handleReqChange.bind(this);
    this.handleFileKeyChange = this.handleFileKeyChange.bind(this);
    this.handleInputPassChange = this.handleInputPassChange.bind(this);
    this.handleCreateCertSubmit = this.handleCreateCertSubmit.bind(this);
  }

  componentDidMount() { }

  handleReqChange() {
    try {
      const file = document.getElementById("fileReq").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {

        this.setState({ reqFileName: file.name, isValidReqFileSize: true, reqFileIsOpen: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer));

          this.setState({
            dataReq: data,
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({ reqFileName: "файл", isValidReqFileSize: false, reqFileIsOpen: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }

  handleFileKeyChange() {
    try {
      const file = document.getElementById("fileKey").files[0];
      //console.log(file);

      if (file !== undefined && file.size < 20000000) {

        this.setState({ filekeyname: file.name, isValidPrivKeyFileSize: true, filekeyIsOpen: true });
        var reader = new FileReader();
        reader.readAsArrayBuffer(file);
        reader.onload = () => {
          const buffer = reader.result;

          const data = new Buffer(new Uint8Array(buffer));

          this.setState({
            dataKey: data,
          });
          //console.log(data);
        };
        reader.onerror = (e) => {
          console.error(e);
        };
      } else {
        this.setState({ filekeyname: "файл", isValidPrivKeyFileSize: false, filekeyIsOpen: false });
      }
    } catch (error) {
      //console.log(error);
    }
  }
  handleInputPassChange(e) {
    try {
      //console.log(e.target.value);
      this.setState({ password: e.target.value });
    } catch (error) {
      //console.log(error);
    }
  }

  handleCreateCertSubmit(e) {
    e.preventDefault();
    try {
      e.preventDefault();
      CreateCertificate(
        this.state.dataReq,
        this.state.dataKey,
        this.state.password
      ).then((result) => {
        try {
          if (result.status === 200) {
            FileDownload(result.data.certificate, "certificate.pem");
            document.getElementById("view").style.borderColor = "green";
          } else {
            document.getElementById("view").style.borderColor = "red";

            this.setState({
              statusGenPrivKey: "Ошибка",
            });
          }
        } catch (error) {
          //console.log(error);
          document.getElementById("view").style.borderColor = "red";

          this.setState({
            statusGenPrivKey: "Ошибка",
          });
        }
      });
      //console.log(this.state.subject);

      //console.log(this.state.password);
      //console.log(this.state.fileKey);
    } catch (error) {
      //console.log(error);
    }
  }
  render() {
    return (
      <div className="">
        <h5 className="major">Создание сертификата</h5>
        <Form onSubmit={this.handleCreateCertSubmit}>
          <div className="sm-4">
            <Form.Group>
              <Form.Label>Выберите запрос на выпуск сертификата</Form.Label>
              <Form.File custom>
                <Form.File.Input
                  onChange={this.handleReqChange}
                  id="fileReq"
                  isValid={this.state.reqFileIsOpen}
                  isInvalid={!this.state.isValidReqFileSize}

                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.reqFileName}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>

            <Form.Group>
              <Form.Label>Выберите файл личного ключа</Form.Label>
              <Form.File custom>
                <Form.File.Input
                  id="fileKey"
                  isValid={this.state.filekeyIsOpen}
                  isInvalid={!this.state.isValidPrivKeyFileSize}

                  onChange={this.handleFileKeyChange}
                />
                <Form.File.Label data-browse="Выбрать">
                  {this.state.filekeyname}
                </Form.File.Label>
                <Form.Control.Feedback type="valid" />
                <Form.Control.Feedback type="invalid">
                  максимальный размер файла 20мб
                </Form.Control.Feedback>
              </Form.File>
            </Form.Group>
            <Form.Group>
              <Form.Label>Введите пароль личного ключа</Form.Label>
              <Form.Control
                onChange={this.handleInputPassChange}
                type="password"
                placeholder="Пароль"
                minLength={8}
                required
                style={{ color: 'white' }}
              />
            </Form.Group>
            <Form.Label style={{ float: "left" }}>
              {this.state.statusCert}
            </Form.Label>

            <Button
              style={{ float: "right" }}
              type="submit"
              size="sm"
            >
              Сгененрировать
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}
export default connect()(withRouter(CreateCert));
